module.exports = __webpack_public_path__ + "static/media/oswald-variablefont_wght-webfont.4a59d23d.woff2";